/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect } from 'react';
import '../styles/Landing.css';
import Logo from '../components/Logo';
import { IconArrow } from '../components/Icons';
import usePageMeta from '../hooks/usePageMeta';

const webappUrl =
  process.env.REACT_APP_PABSYNC_WEBAPP_URL || 'https://app.pabsync.com';

const buildTarget = () => {
  const params = new URLSearchParams(window.location.search);
  const plan = params.get('plan') || 'free';
  const seats = params.get('seats');
  const target = new URL(`${webappUrl}/register`);
  target.searchParams.set('plan', plan);
  target.searchParams.set('src', 'website');
  if (seats) target.searchParams.set('seats', seats);
  return target.toString();
};

const RegistrationPage: React.FC = () => {
  usePageMeta({
    title: 'Create your account | PabSync',
    description: 'Redirecting you to create your PabSync account.',
    path: '/registration',
    noindex: true,
  });

  useEffect(() => {
    // Always send the user to the registration page in the web app.
    window.location.replace(buildTarget());
  }, []);

  const onContinue = useCallback(() => {
    window.location.href = buildTarget();
  }, []);

  return (
    <div className="redirect">
      <div className="redirect__card">
        <Logo size={34} />
        <div className="redirect__spinner" aria-hidden="true" />
        <h1>Taking you to sign up…</h1>
        <p>
          You’re being redirected to create your PabSync account. If nothing
          happens, continue below.
        </p>
        <div className="redirect__actions">
          <button className="btn btn--primary btn--lg" onClick={onContinue}>
            Continue to sign up <IconArrow size={18} />
          </button>
          <a className="btn btn--ghost btn--lg" href="/">
            Back to homepage
          </a>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPage;
